import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// Маркер «без НДС» у цены. Inline-span: наследует размер цены (`inherit`), но приглушён нормальным
// весом и цветом gray.7 — отделяется от жирного числа, оставаясь читаемым. Ставится после каждой цены.
// Бизнес-решение: в UI все суммы без НДС; сам НДС присутствует только в документах (счета, УПД).
export default function NoNds() {
  const { t } = useTranslation();
  return (
    <Text span inherit fw={400} c="gray.7">
      {' '}
      {t('common.noNds')}
    </Text>
  );
}
